import { Typography } from '@mui/material';


export const Headline = () => {

    return (
        <>
            <Typography variant='h1'>
                STEVEN DUVAL
            </Typography>
            <Typography component='p' variant='h6' color='text.secondary'>
                Front-End Developer based in the Miami-Fort Lauderdale Area
            </Typography>
        </>
    );
    
}